import Transformer from './Transformer';

class itemTransformerBygenre extends Transformer {
    transform(model, params, url) {
        
        return {
            api: url,
            id: model.id,
            channelNumber: model.contentAttributes.channelNumber,
            title: model.contentAttributes.channelTitle,
            channelBlocked: true, //Obtener el valor de algún lado
            channelImage: model.contentAttributes.channelImage,
            data: model,
            subtitle: model.title,
            dateBegin: model.contentAttributes.dateBegin,
            dateEnd: model.contentAttributes.dateEnd,
            group_id: model.contentAttributes.groupId,
            event: model.events,
            type: 'UserLiveChannel',
        }
    }
}

export default new itemTransformerBygenre();



// WEBPACK FOOTER //
// ./src/requests/tasks/transformers/itemTransformerBygenre.js